// One row on Today for the evening: a smoke in one tap, and the next thing
// the evening wants (End of day, the chair, the check-in). Small, and it
// never says what was missed.
import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Armchair, Cigarette, ClipboardCheck, Moon } from 'lucide-react'
import { useDays } from '@/db/hooks'
import { useNow } from '@/hooks/useNow'
import { eveningOf, logSmoke, summarise } from '@/lib/wellbeing'
import { Button } from './ui'

/** `children` sit at the end of the row: Today puts its filter button there. */
export const WellbeingRow = ({ children }: { children?: ReactNode }) => {
  const days = useDays()
  const now = useNow(60_000)
  const date = eveningOf(now)
  const rec = days.find((d) => d.spec.date === date)?.spec
  const s = rec ? summarise(rec) : undefined
  const next = !rec?.ended_at
    ? { to: '/wellbeing' as const, label: 'End of day', Icon: Moon }
    : !s?.resetDone
      ? { to: '/reset' as const, label: 'The chair', Icon: Armchair }
      : !s.checkedIn
        ? { to: '/checkin' as const, label: 'Check in', Icon: ClipboardCheck }
        : null
  return (
    <div className="flex items-center gap-2 mb-3" data-testid="wellbeing-row">
      <Button variant="chip" onClick={() => void logSmoke(date)} data-testid="today-smoke">
        <Cigarette size={13} />
        {s && s.smokeTotal > 0 ? `${s.smokeTotal}` : 'Smoke'}
      </Button>
      <span className="text-xs text-faint truncate min-w-0" data-testid="today-smoke-line">
        {s && s.smokeTotal > 0 ? `first at ${s.firstSmoke}` : ''}
      </span>
      <span className="flex-1" />
      {next ? (
        <Link to={next.to} className="contents">
          <Button variant="chip" data-testid="today-evening">
            <next.Icon size={13} /> {next.label}
          </Button>
        </Link>
      ) : (
        <Link to="/wellbeing" className="text-xs text-muted" data-testid="today-evening">
          Tonight's done
        </Link>
      )}
      {children}
    </div>
  )
}
